import React, { useEffect, useState } from "react";
import {
  ButtonContainer,
  ButtonWrapper,
  PanelContainer,
  VideoContainer,
  TitleContainer,
  TextContainer,
} from "./index.styled";
import videoBg from "../../assets/images/videoBg.svg";
import playBtn from "../../assets/images/play.svg";
import { Container } from "../../pages/AvaNegarLanding/index.styled";
import { CustomButton } from "../buttons/index.styled";
import { env } from "../../.env";
const LandingPanel = () => {
  /**
   * @desc link handler. after click user redirect to https://test-avanegar.partdp.ir/
   * @function
   */
  const linkHandler = () => {
    window.location.href = env.REACT_APP_PANEL_REDIRECT;
  };

  // <circles
  const [circles, setCircles] = useState([]);

  useEffect(() => {
    let arr = [];
    for (let i = 1; i <= 3; i++) {
      const circle = <div className={`circle${i}`}></div>;
      arr.push(circle);
    }
    setCircles(arr);
  }, []);
  // circles>

  return (
    <Container>
      <PanelContainer>
        <VideoContainer>
          {circles.slice(0, 3).map((item) => item)}
          <img src={videoBg} alt="video" />

          {/* <ButtonContainer>
            <img src={playBtn} alt="play button" />
          </ButtonContainer> */}
        </VideoContainer>
        <TitleContainer
          color="#12A46F"
          titleColor="#8C8D9B"
          textColor="#2D3134"
          // width="40%"
        >
          <h5>دمو</h5>
          <TextContainer width="440px">
            <span></span>
            <h4>پنل کاربری</h4>
            <p>
              پنل کاربری آوانگار به شما این امکان را می‌دهد که با یک رابط کاربری
              ساده اما کاربردی به آسانی داده های سرویس آوانگار را روی محصولات
              نرم افزاری خود رصد و کنترل کنید. و از همه امکانات سرویس تبدیل آوا
              به متن استفاده کنید.
            </p>
          </TextContainer>
          <CustomButton
            width="138px"
            height="48px"
            radius="2px"
            color="#FFFFFF"
            background="#12A46F"
            borderColor="#12A46F"
            backgroundHover="#FFFFFF"
            borderColorHover="#12A46F"
            colorHover="#12A46F"
            fontWeight="700"
            onClick={linkHandler}
          >
            ورود به حساب
          </CustomButton>
        </TitleContainer>
      </PanelContainer>
    </Container>
  );
};

export default LandingPanel;
